import { __assign, __read, __spread } from "tslib";
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { isEmpty } from 'lodash-es';
import { Box, Grid } from '@marvelapp/ui';
import { ItemUtils, selectors } from '@marvelapp/design-creator';
import { getExpandedAncestors } from './utils';
import { useLayerFilter } from './hooks';
import LayerListItem from './LayerListItem';
import { LayerListFilterEmptyState } from './LayerListFilterEmptyState';
import { LayerListContext } from './context';
/** @param {any} */
function LayerList(_a) {
    var design = _a.design, _b = _a.selectedIds, selectedIds = _b === void 0 ? [] : _b, onSelect = _a.onSelect, onLayerMouseEnter = _a.onLayerMouseEnter, onLayerMouseLeave = _a.onLayerMouseLeave, filterText = _a.filterText;
    var rootIds = ItemUtils.getChildIds(selectors.getRoot(design)) || [];
    var itemsMap = design.items || {};
    var _c = __read(useState({}), 2), expandedMap = _c[0], setExpandedMap = _c[1];
    var filter = useLayerFilter(design, filterText);
    var rootItems = useMemo(function () { return __spread(rootIds).reverse(); }, [rootIds]);
    useEffect(function () {
        if (selectedIds) {
            var updatedExpandedMap_1 = getExpandedAncestors(design, selectedIds);
            setExpandedMap(function (prevState) {
                return __assign(__assign({}, prevState), updatedExpandedMap_1);
            });
        }
    }, [design, selectedIds]);
    var onSelectItem = useCallback(function (itemId, event) {
        onSelect(itemId, event);
    }, [onSelect]);
    var onMouseEnterItem = useCallback(function (itemId) {
        if (onLayerMouseEnter) {
            onLayerMouseEnter(itemId);
        }
    }, [onLayerMouseEnter]);
    var onMouseLeaveItem = useCallback(function (itemId) {
        if (onLayerMouseLeave) {
            onLayerMouseLeave(itemId);
        }
    }, [onLayerMouseLeave]);
    var setIsExpandedLayer = useCallback(function (layerId, isExpanded) {
        setExpandedMap(function (prevState) {
            var _a;
            return __assign(__assign({}, prevState), (_a = {}, _a[layerId] = isExpanded, _a));
        });
    }, [setExpandedMap]);
    var contextValue = {
        selectedIds: selectedIds,
        expandedMap: expandedMap,
        itemsMap: itemsMap,
        filter: filter,
        setIsExpandedLayer: setIsExpandedLayer,
    };
    var showFilterEmptyState = filter.filterText && isEmpty(filter.filteredItems);
    return (React.createElement(LayerListContext.Provider, { value: contextValue },
        React.createElement(Box, { "data-testid": "layer-list", flex: 1, overflowY: "scroll", padding: 2 },
            React.createElement(Grid, { gridRowGap: 1, gridTemplateColumns: "100%" }, rootItems.map(function (id) { return (React.createElement(LayerListItem, { item: itemsMap[id], key: id, onMouseEnter: onMouseEnterItem, onMouseLeave: onMouseLeaveItem, onSelect: onSelectItem })); })),
            showFilterEmptyState && (React.createElement(LayerListFilterEmptyState, { filterText: filterText })))));
}
export default React.memo(LayerList);
